import { styled } from '@mui/material/styles'
import { useRevalidator } from 'react-router-dom'
import { useNotifications } from '@toolpad/core'
import Stack from '@mui/material/Stack'
import Badge, { badgeClasses } from '@mui/material/Badge'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded'
import TableButton from 'components/TableButton/TableButton'
import { api } from 'index'
import { declination } from 'utils/declination'

const StyledBadge = styled(Badge)(({ theme }) => ({
  [`& .${badgeClasses.badge}`]: {
    border: `1px solid ${theme.vars.palette.background.default}`,
  },
}))

function DataGridControls({ dataGridSelectedRows, dataGridApiRef }) {
  const notifications = useNotifications()
  const revalidator = useRevalidator()

  const handleRowSelectionChange = () => {
    if (dataGridSelectedRows.length) {
      dataGridApiRef.current.setRowSelectionModel([])

      return
    }

    const rowIds = dataGridApiRef.current.getAllRowIds()
    dataGridApiRef.current.setRowSelectionModel(rowIds)
  }

  const handleDeleteRows = async () => {
    const rowIds = dataGridSelectedRows.map(({ id }) => id)
    const isBatch = rowIds.length > 1
    const ids = isBatch ? rowIds : rowIds.toString()

    const newsletterWord = declination(rowIds.length, [
      'Рассылка',
      'Рассылки',
      'Рассылок',
    ])

    const deleteWord = declination(rowIds.length, [
      'удалена',
      'удалены',
      'удалено',
    ])

    try {
      const namespace = isBatch ? 'batch' : 'item'
      const { errors } = await api.newsletters[namespace].delete(ids)

      if (errors.length) throw new Error(errors.toString())

      revalidator.revalidate()

      notifications.show(
        `${isBatch ? rowIds.length : ''} ${newsletterWord} ${deleteWord}`.trim(),
        {
          severity: 'success',
          autoHideDuration: 5000,
        }
      )
    } catch (e) {
      notifications.show(
        `${isBatch ? rowIds.length : 1} ${newsletterWord} не ${deleteWord}: ${e.message}`,
        {
          severity: 'error',
        }
      )
    }
  }

  return (
    <Stack direction="row" spacing={1.2} useFlexGap>
      <TableButton
        onClick={handleRowSelectionChange}
        icon={
          <StyledBadge
            badgeContent={dataGridSelectedRows.length}
            color="primary"
          >
            {dataGridSelectedRows.length ? (
              <CheckCircleRoundedIcon />
            ) : (
              <CheckCircleOutlineRoundedIcon />
            )}
          </StyledBadge>
        }
      >
        {dataGridSelectedRows.length ? 'Снять выделение' : 'Выделить все'}
      </TableButton>

      {dataGridSelectedRows.length ? (
        <TableButton
          icon={<DeleteForeverRoundedIcon />}
          onClick={handleDeleteRows}
        >
          Удалить
        </TableButton>
      ) : null}
    </Stack>
  )
}

export default DataGridControls
